import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import MfaSetup from '../components/auth/MfaSetup';

/** Shown once right after login/register when the account is privileged but has never enrolled in
 *  MFA (see EnsureMfaVerified — this is a nudge, not a gate, so skipping just continues on). */
const MfaPromptPage = () => {
  const { refreshProfile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const destination = location.state?.destination || '/dashboard';

  const proceed = async () => {
    await refreshProfile();
    navigate(destination, { replace: true });
  };

  return (
    <div style={{ maxWidth: 480, margin: '40px auto', padding: '0 20px' }}>
      <div className="card">
        <div className="card-body">
          <MfaSetup onComplete={proceed} />
          <button
            type="button"
            className="btn-secondary"
            style={{ marginTop: 16, width: '100%' }}
            onClick={() => navigate(destination, { replace: true })}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
};

export default MfaPromptPage;
